// Lead domain constants. Status codes mirror the sourcing backend.

export const LEAD_STATUS = {
  NEW: 'NEW',
  ONGOING: 'ONG',
  CLOSED: 'CLOSED',
  LOST: 'LOST',
};

export const LEAD_STATUS_OPTIONS = [
  { label: 'New', value: LEAD_STATUS.NEW },
  { label: 'Ongoing', value: LEAD_STATUS.ONGOING },
  { label: 'Closed', value: LEAD_STATUS.CLOSED },
  { label: 'Lost', value: LEAD_STATUS.LOST },
];

export const DEFAULT_LEAD_STATUS = LEAD_STATUS.NEW;

// Lead list period filter (maps to mutually-exclusive backend query flags).
export const LEAD_PERIOD = {
  CURRENT_MONTH: 'current_month_leads',
  PAST_30_DAYS: 'leads_from_past_30days',
};

export const LEAD_PERIOD_OPTIONS = [
  { label: 'Current Month Leads', value: LEAD_PERIOD.CURRENT_MONTH },
  { label: 'Leads from Past 30 Days', value: LEAD_PERIOD.PAST_30_DAYS },
];
